"use strict";
import React from 'react';
import AlertActions from '../../actions/AlertActions';
import { Player, ControlBar, ReplayControl, ForwardControl} from 'video-react';
import "video-react/dist/video-react.css"; // import css
const WAITING_HISTORY_COUNT = 20;
class VideoPlayer extends React.Component {
    constructor() {
        super();
        this.state = {
          isLoaded:false,
        };
        this.lastWaiting = [];
        for (var i = 0; i < WAITING_HISTORY_COUNT; i++) {
          this.lastWaiting.push(0);
        }    
      };
    
      static propTypes = {
        onProgress: React.PropTypes.func,
        onPlay: React.PropTypes.func,
        onPause: React.PropTypes.func,
        ctrls: React.PropTypes.bool,
        mute: React.PropTypes.bool
      };
    
      componentDidMount() {
        // console.log("this.video.video.video-----",this.video.video);
          this.video.video.video.addEventListener('timeupdate', this.props.onProgress);
          this.video.video.video.addEventListener('loadeddata', ()=>{
          if(this.props.onLoadedData){
            this.props.onLoadedData();
          }
          
        });
        this.video.video.video.addEventListener('seeked', ()=>{
          if(this.props.onLoadedData){
            this.props.onLoadedData();
          }
        });
        setInterval(()=>{
          // console.log("buffered=======",this.video.getState().player.buffered);
          
        }, 1000);
        this.bufferingTimeoutId =  setTimeout(()=>{
          this.bufferingIntervalId = setInterval(() => {
            let history = 0;
            // console.log("this",this.video.getState().player.waiting);
            let waiting = this.video.getState().player.waiting ? 1 : 0;
            this.lastWaiting.shift();
            this.lastWaiting.push(waiting); 
            for (var i = 0; i < this.lastWaiting.length; i++) {
              history += this.lastWaiting[i];
            }
            if (history >= WAITING_HISTORY_COUNT) {
              if(this.props.onBuffering  && typeof this.props.onBuffering == 'function'){
                this.props.onBuffering();
              }
            }

            const {buffered : bufferedSlots, autoPaused, paused} = this.video.getState().player;
            // console.log("bufferedSlots.length====", bufferedSlots.length);
            if(bufferedSlots && bufferedSlots.length){
              // console.log("this.prevBufferedSlotsLength====", this.prevBufferedSlotsLength);
              if(!this.prevBufferedSlotsLength || this.prevBufferedSlotsLength !== bufferedSlots.length){
                this.prevBufferedSlotsLength = bufferedSlots.length;
                console.log("autoPaused======", autoPaused, paused);
                if (this.props.dontAutoStartTheVideo) return;
                if(autoPaused || paused) this.play();
              }
            }
          }, 100);
        }, 5000);
        this.video.video.video.addEventListener('play', ()=>{
          if(this.props.onPlay){
            this.props.onPlay();
          }
        
          if(this.video.readyState==4){
            AlertActions.success({message: 'Your video is ready'});
          }else{{
            //AlertActions.error({message: 'Please wait ...'});
          }}
        });

        this.video.video.video.addEventListener('pause', ()=>{
          if(this.props.onPause) this.props.onPause();
        });

      };
    
      componentWillUnmount() {
        //todo why do we need to pass the callback in case of removeEventListener
        this.video.pause();
        clearTimeout(this.bufferingTimeoutId);
        clearInterval(this.bufferingIntervalId);
        this.video.video.video.removeEventListener('timeupdate', this.props.onProgress);
        this.video.video.video.removeEventListener('play', this.props.onPlay);
        this.video.video.video.removeEventListener('loadeddata', ()=>{
        });
        this.video.video.video.removeEventListener('seeked', ()=>{
        });
      }

      render(){
        const {url, autoHide = true, preload = "auto", poster = undefined } = this.props;
        const mute = this.props.hasOwnProperty('mute') ? this.props.mute : false;
        const ctrls = this.props.hasOwnProperty('ctrls') ? this.props.ctrls : true;


       return (
        <div className="embed-responsive-item height-100">
            <div className="embed-responsive embed-responsive-16by9">
                <Player
                  autoPlay={false}
                  ref={ elem => this.video = elem }
                  poster={poster}
                  src={ url }
                  preload={preload}
                >
                <ControlBar autoHide={autoHide} disabled={!ctrls}> 
                <ReplayControl seconds={10} order={2.2} />
                <ForwardControl seconds={10} order={2.3} />
                </ControlBar>
                </Player>
            </div>
        </div>
       )     
    }
      getDimensions() {
        return this.video && {height: this.video.offsetHeight, width: this.video.offsetWidth};
      };
      getCurrentTime(){
        // console.log("this.video.video.video--------",this.video.video.video);
        return this.video.video.video.currentTime;
      }
      // setCurrentTime (){
      //   this.video.video.video.currentTime = 0;
      // }
      seekTo(time) {
        // console.log("enter in seekTo");
        // this.video.currentTime = time;
        this.video.seek(time);
      }
      play(){
        console.log("enter in play");
        var nopromise = {
          catch: new Function()
        };
        (this.video.play() || nopromise).catch(function () {
        });
      }
      autoplay(time) {
        // console.log("enter in auto play");
        this.video.pause((response)=>{
        });//this pause helps with detection of onPlay
        // this.video.currentTime = time;
        this.video.seek(time);
        var nopromise = {
          catch: new Function()
        };
        (this.video.play() || nopromise).catch(function (err) {
          // console.log("error in playing video------",err);
        });
      }    
}
export default VideoPlayer;
